import React from 'react';
import { useSelector } from 'react-redux';
import CehckListModal from 'src/components/CheckListModal/ChecklistModal';
import IconInput from '../../../components/IconInput/IconInput';
import { operationsList, producerOperationsList } from '../operationsList';
import arrowDown from 'src/assets/arrowDown.png';
import { Selection } from '@typeRoots/common/checkListModal';
import { RootState } from 'src/store/store';

interface OperationsSectionProps {
  operations: {
    isModalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
    selectedOperations: string[];
    selectedCommodities: Selection[]; // Updated type for selectedCommodities
    setSelection: (selection: Selection[]) => void; // Updated type for setSelection
    setSelectedOperations: (operations: string[]) => void;
  };
}

const OperationsSection: React.FC<OperationsSectionProps> = ({ operations }) => {
  const accountType = useSelector((state: RootState) => state.UI.accountType);
  const list =
    accountType === 'producer' ? { ...producerOperationsList, ...operationsList } : operationsList;

  const handleModalSave = (newSelection: Selection[]) => {
    operations.setSelection(newSelection);
    const updatedOperations = newSelection.map((item) => item.subtype.name);
    operations.setSelectedOperations(updatedOperations);
    operations.setModalVisible(false);
  };

  return (
    <>
      <IconInput
        testID={'insurance-policy-final-operation'}
        label="Your Operations"
        value={operations.selectedOperations.join(', ')}
        placeholder="No operations selected"
        iconSource={arrowDown}
        iconWidth={20}
        iconHeight={20}
        onPress={() => operations.setModalVisible(true)}
        onIconPress={() => operations.setModalVisible(true)}
      />
      <CehckListModal
        parentTestID={'insurance-policy-final-company-operation'}
        isVisible={operations.isModalVisible}
        initialSelections={operations.selectedCommodities}
        handleSelectionChange={handleModalSave}
        onClose={() => operations.setModalVisible(false)}
        title={`Please choose your company’s operations`}
        list={list}
        hasSearch
        searchPlaceholder="Search operations"
      />
    </>
  );
};

export default OperationsSection;
